import { render, staticRenderFns } from "./ScopeLabelInput.vue?vue&type=template&id=87f79296"
import script from "./ScopeLabelInput.vue?vue&type=script&lang=js"
export * from "./ScopeLabelInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports